/**
 * Firebase web config for FCM (browser push).
 * Set REACT_APP_FIREBASE_* and REACT_APP_FIREBASE_VAPID_KEY in .env
 * (see MOBILE_PUSH_SETUP.md). Leave empty to disable web push.
 */

export function getFirebaseWebConfig() {
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY || '';
  const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '';
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || '';
  const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '';
  const appId = process.env.REACT_APP_FIREBASE_APP_ID || '';
  const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '';
  const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '';

  if (!apiKey || !projectId || !messagingSenderId || !appId) {
    return null;
  }

  return {
    apiKey,
    authDomain: authDomain || `${projectId}.firebaseapp.com`,
    projectId,
    messagingSenderId,
    appId,
    ...(storageBucket ? { storageBucket } : {}),
    ...(measurementId ? { measurementId } : {}),
  };
}

export function getFirebaseVapidKey() {
  return process.env.REACT_APP_FIREBASE_VAPID_KEY || '';
}

export function isFirebaseWebPushConfigured() {
  return Boolean(getFirebaseWebConfig() && getFirebaseVapidKey());
}
